// extracted by mini-css-extract-plugin
export default {"status":"ServerError_status__+Z9A8","title":"ServerError_title__ORBLO","message":"ServerError_message__WGYDQ"};